import { Component } from 'react';
import PropTypes from 'prop-types';
import { inject } from 'mobx-react';

class LoanpartOverviewTabsComponent extends Component {
  constructor(props) {
    super(props);

    this.onClickHandler = this.onClickHandler.bind(this);
  }

  onClickHandler(e) {
    this.props.CalculationOutputData.setActiveLoanpartOverviewTab(e.target.id);
  }

  render() {
    // eslint-disable-next-line react/prop-types
    const loanPartsLength = this.props.CalculationOutputData.shallowFormDataCopy.loanparts.length;
    let tabComponents = this.props.CalculationOutputData.allTabs.map((tab, index) => {
      let activeTabClass;
      let row = null;

      if (index <= loanPartsLength) {
        if (tab.id === this.props.CalculationOutputData.activeLoanpartOverviewTabId) {
          activeTabClass = 'calculation-container__loanpart-overview-tab--active';
        }

        row = (
          <li className={`calculation-container__loanpart-overview-tab ${activeTabClass}`} key={tab.name}>
            <a
              role="button"
              onClick={this.onClickHandler}
              id={tab.id}
            >
              {tab.name}
            </a>
          </li>
        );
      }

      return row;
    })
      .filter(tabComponent => tabComponent);

    /* Only show total summary tab when there is only one loanpart . */
    if (tabComponents.length === 2) {
      tabComponents = tabComponents.slice(0, 1);
    }

    return (
      <div>
        <ul className="calculation-container__loanpart-overview-tabs">
          {tabComponents}
        </ul>
      </div>
    );
  }
}

LoanpartOverviewTabsComponent.propTypes = {
  CalculationFormData: PropTypes.shape({
    mortgageForm: PropTypes.shape({
      loanparts: PropTypes.arrayOf(PropTypes.number),
    }),
  }),
  CalculationOutputData: PropTypes.shape({
    allTabs: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
    activeLoanpartOverviewTabId: PropTypes.string,
    setActiveLoanpartOverviewTab: PropTypes.func,
  }),
};

LoanpartOverviewTabsComponent.defaultProps = {
  CalculationFormData: {
    mortgageForm: {},
  },
  CalculationOutputData: {
    setActiveLoanpartOverviewTab: () => {},
    allTabs: [],
    activeLoanpartOverviewTabId: '',
  },
};

export default inject('CalculationOutputData', 'CalculationFormData')(LoanpartOverviewTabsComponent);
